import React, { useEffect, useState } from 'react';
import get from 'lodash/get';
import { useField } from 'formik';

import { useTranslation } from 'react-i18next';
import FileClick from './FileClick.jsx';
import FileDrop from './FileDrop.jsx';
import FieldFileSlide from './FieldFileSlide.jsx';
import FileProgress from './FileProgress.jsx';
import useFileUpload from '../hooks/useFileUpload';

const FieldFileUpload = ({
  api,
  className = '',
  name,
  fileOpts = {},
}) => {
  const { validate, ...tfOpts } = fileOpts;
  const fOpts = { accept: 'image/jpeg, image/png', ...tfOpts };
  const [validationError, setValidationError] = useState(null);
  const [, { value }, { setTouched, setValue }] = useField({ name });
  const onFileAdd = async ([f]) => {
    if (f) {
      console.log('[FieldFileUpload] onFileAdd', {
        name: f.name,
        type: f.type,
        size: f.size,
        lastModified: f.lastModified,
      });
      setValidationError(null);
      if (typeof (validate) === 'function') {
        try {
          await validate(f);
        } catch (e) {
          console.warn('[FieldFileUpload] validate failed', e);
          setValidationError(e);
          return;
        }
      }
      setValue(f);
    }
  };
  const onFileRemove = () => {
    setValidationError(null);
    setValue(null);
    setTouched(true);
  };
  const { t } = useTranslation();
  const [res, req, , progress] = useFileUpload();
  const isPending = res.status === 'pending';
  const hasValue = Boolean(value);



  useEffect(() => {
    if (value instanceof File) {
      (async () => {
        // display.current = URL.createObjectURL(value);
        try {
          const { payload } = await req({ url: api }, value);
          setValue(payload.url);
          setTouched();
        } catch (e) {
          console.error('[FieldFileUpload] upload failed', e);
        }
      })();
    }
  }, [
    value instanceof File,
    get(value, 'name') || value,
    get(value, 'lastModified'),
  ]);

  return (
    <>
    <div className="input-group">
      <div className={`${className}`}>
        {value && !(value instanceof File) && (
        <a href={value} target="_blank" rel="noreferrer">{value}</a>
        )}
      </div>
      <div className="input-group-append">
        <FileDrop className="d-inline-block" onDrop={onFileAdd} {...fOpts}>
          <FileClick className="d-inline-block" onFile={onFileAdd} {...fOpts}>
          {isPending ? (
            <div className="opacity-9">
              <span className="btn btn-secondary">
                <FileProgress progress={progress} />
              </span>
            </div>
          ) : (
            <div className="tra-opacity opacity-8 hvr-opacity-10">
              <span className="btn btn-secondary">
                {t('Drop your file or')} <u>{t('Browse')}</u>
              </span>
            </div>
          )}
          </FileClick>
        </FileDrop>
        {hasValue && (
          <button
            type="button"
            className="btn btn-outline-secondary ml-2"
            onClick={onFileRemove}
            disabled={isPending}
          >
            {t('Remove')}
          </button>
        )}
      </div>
    </div>
    {validationError && (
      <div className="text-danger">
        {validationError.message || validationError}
      </div>
    )}
    </>
  );
};

export default FieldFileUpload;
